import axios from "axios";
import { BaseURL } from "../../services/modules/utils/constant";
import handleErrors from "../../services/modules/utils/handel_error";

export const reduxRequest = async ({
  dispatch,
  isLoading,
  url,
  method = "post",
  loadingType = "list",
  data: body,
  action,
  successFunction,
  failFunction,
  variables = {},
  headers,
}) => {
  dispatch(
    isLoading({
      type: loadingType,
      loading: true,
    })
  );
  try {
    const { data } = await axios({
      url: url,
      baseURL: BaseURL,
      method: method,
      data: body,
      headers,
    });
    successFunction && dispatch(successFunction(data, variables)); //data is used to extract id to update the state
    action && action(data);
  } catch (error) {
    handleErrors(error);
    failFunction && dispatch(failFunction(error));
  } finally {
    dispatch(
      isLoading({
        type: "",
        loading: false,
      })
    );
  }
};
